import { Swiper, SwiperSlide } from 'swiper/react';
import { useGetAvailableContactsQuery } from 'services/event.service';
import { useAuth } from 'modules/auth/context/AuthContextV2';
import 'swiper/css';
import CalendarCard from './Updates/CalendarCard';
import InviteFriendsCard from './Updates/InviteFriendsCard';
import FriendsCard from './Updates/FriendsCard';
import InviteEventCard from './Updates/InviteEventCard';
import { UpdateCard } from '../hooks/useUpdates';
import SendMessageCard from './Updates/SendMessageCard';
import { useEffect, useMemo, useRef, useState } from 'react';
import HomeAICard from '../homeAI/components/HomeAICard';

type Props = {
  updates: UpdateCard[];
  handleDismiss: (eventId: string, expiresAt?: Date) => void;
};

const Updates = ({ updates, handleDismiss }: Props) => {
  const { data: availableContacts, refetch } = useGetAvailableContactsQuery();
  const { user } = useAuth();
  const swiperRef = useRef<any>(null);
  const [updatesHeight, setUpdatesHeight] = useState(0);

  useEffect(() => {
    if (swiperRef.current?.swiper?.slides[0]) {
      setUpdatesHeight(
        swiperRef.current.swiper.slides[0].getBoundingClientRect().height,
      );
    }
  }, [swiperRef.current?.swiper?.slides.length]);

  useEffect(() => {
    refetch();
  }, [availableContacts, user?.contacts]);

  const updateHeight = () => {
    if (swiperRef.current) {
      const activeIndex = swiperRef.current.swiper.activeIndex;
      const activeSlide = swiperRef.current.swiper.slides[activeIndex];

      if (activeSlide) {
        const currentCardHeight = activeSlide.getBoundingClientRect().height;
        setUpdatesHeight(currentCardHeight);
      }
    }
  };
  const filteredAvailableContacts = useMemo(() => {
    return availableContacts?.data?.filter((contact) => {
      return contact._doc?.userId !== user?.id;
    });
  }, [availableContacts, user]);

  if (!user) {
    return <div className="flex items-center justify-center"></div>;
  }

  return (
    <Swiper
      slidesPerView={1}
      spaceBetween={50}
      ref={swiperRef}
      autoHeight={true}
      onSlideChange={updateHeight}
      style={{
        height: updatesHeight,
        width: '100%',
        overflow: 'visible',
        transition: 'height 0.3s ease-in-out',
      }}
    >
      {updates
        .filter((event) => event.type === 'event')
        .map((event: any, index: number) => (
          <SwiperSlide
            key={index}
            className="relative h-fit shadow-[0px_-20px_40px_1px_#401DBD] rounded-[4rem]"
          >
            <InviteEventCard
              event={event.eventData}
              handleDismiss={handleDismiss}
            />
          </SwiperSlide>
        ))}
      {updates.find(
        (event) =>
          event.type === 'friends' &&
          filteredAvailableContacts &&
          filteredAvailableContacts?.length > 0,
      ) && (
        <SwiperSlide className="relative h-fit shadow-[0px_-20px_40px_1px_#401DBD] rounded-[6rem]">
          <FriendsCard handleDismiss={handleDismiss} />
        </SwiperSlide>
      )}
      <SwiperSlide className="relative h-fit shadow-[0px_-20px_40px_1px_#401DBD] rounded-[6rem]">
        <HomeAICard />
      </SwiperSlide>
      {updates.find((event) => event.type === 'sendMessage') && (
        <SwiperSlide className="relative h-fit shadow-[0px_-20px_40px_1px_#401DBD] rounded-[6rem]">
          <SendMessageCard handleDismiss={handleDismiss} />
        </SwiperSlide>
      )}
      {!user.isCalendarSync &&
        updates.find((event) => event.type === 'calendar') && (
          <SwiperSlide className="relative h-fit shadow-[0px_-20px_40px_1px_#401DBD] rounded-[6rem]">
            <CalendarCard handleDismiss={handleDismiss} />
          </SwiperSlide>
        )}
      {updates.find((event) => event.type === 'inviteFriends') && (
        <SwiperSlide className="relative h-fit shadow-[0px_-20px_40px_1px_#401DBD] rounded-[6rem]">
          <InviteFriendsCard handleDismiss={handleDismiss} />
        </SwiperSlide>
      )}
    </Swiper>
  );
};

export default Updates;
